import React from "react"
import "./GridViewCard.scss"
import PropTypes from "prop-types"
import {
  ComplianceCircle,
  ComplianceText,
  NOT_ENOUGH_DATA,
  complianceNumberConverter,
} from "@swipesense/compliance-helpers"
import OverviewCard from "../OverviewCard"
import {
  NR_MIN_OPPORTUNITIES,
  BSR_MIN_OPPORTUNITIES,
} from "../../helpers/sharedConstants"
import { connect } from "react-redux"

const GridView = props => {
  const compliance = complianceNumberConverter(
    props.compliance,
    props.opportunities
  )

  return (
    <div className="GridViewCard">
      <OverviewCard>
        {props.picture && <div className="card-picture" />}
        <div className="gradient-bar" />
        <div className="card-body">
          <div className="card-overview">
            <div className="name">{props.name}</div>
            <ComplianceCircle
              compliance={props.compliance}
              opportunities={props.opportunities}
              displayOnHover={compliance < 0}
              minOpportunities={
                props.bsrCompliance
                  ? BSR_MIN_OPPORTUNITIES
                  : NR_MIN_OPPORTUNITIES
              }
              displayText={
                compliance === NOT_ENOUGH_DATA ? "NED" : null // NOT_ENOUGH_DATA or NO_DATA
              }
            >
              <ComplianceText
                compliance={props.compliance}
                opportunities={props.opportunities}
                minOpportunities={
                  props.bsrCompliance
                    ? BSR_MIN_OPPORTUNITIES
                    : NR_MIN_OPPORTUNITIES
                }
              />
            </ComplianceCircle>
          </div>
          <div className="card-footer">{props.children}</div>
        </div>
      </OverviewCard>
    </div>
  )
}

GridView.propTypes = {
  name: PropTypes.string.isRequired,
  compliance: PropTypes.number,
  opportunities: PropTypes.number,
  picture: PropTypes.bool,
  children: PropTypes.node,
  bsrCompliance: PropTypes.bool,
}

GridView.defaultProps = {
  compliance: null,
  opportunities: 0,
  picture: false,
}

const GridViewCard = connect(({ bsrCompliance: { bsrCompliance } }) => ({
  bsrCompliance: bsrCompliance,
}))(GridView)

export default GridViewCard
